export default "__VITE_ASSET__DSWZC2Bt__"